import { SchemaValidation } from 'utilities/validationCheck'

export const resetDataFormsSchema = SchemaValidation.object().shape({
  resetDataType: SchemaValidation.string().required('Reset Data harus dipilih'),
  password: SchemaValidation.string()
    .required('Password tidak boleh kosong')
    .min(8, 'Password minimal 8 karakter'),
})
